// extracted by mini-css-extract-plugin
module.exports =  {"root":"H0EXejqgLtQOCaBTXV8Y","spinner":"MKIboewNLVD9GM2dpoyD"};